import React from "react";
import { TripBasicData } from "../types";
import {
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  Divider,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  Button,
} from "@mui/material";
import { Dialog } from "@mui/material";
import { formatDate } from "../../../../utils/utils";
import {
  commonButtonProps,
  tableCellStyles,
  tableHeaderStyles,
} from "../../../../utils/styles";

const BasicChangeLogs = ({
  open,
  onClose,
  changedDetails,
}: {
  open: boolean;
  onClose: () => void;
  changedDetails: TripBasicData;
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography variant="h6">Change Logs</Typography>
          <Button size="small" sx={{ height: 20, fontSize: "0.75rem" }} variant="outlined" onClick={onClose}>
            Close
          </Button>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell style={tableHeaderStyles}>Updated By</TableCell>
                    <TableCell style={tableHeaderStyles}>Updated On</TableCell>
                    <TableCell style={tableHeaderStyles}>Trip Type</TableCell>
                    <TableCell style={tableHeaderStyles}>Start From</TableCell>
                    <TableCell style={tableHeaderStyles}>End To</TableCell>
                    <TableCell style={tableHeaderStyles}>
                      Journey Start Date
                    </TableCell>
                    <TableCell style={tableHeaderStyles}>
                      Journey Return Date
                    </TableCell>
                    <TableCell style={tableHeaderStyles}>
                      Journey Start Odometer Reading
                    </TableCell>
                    <TableCell style={tableHeaderStyles}>
                      Journey End Odometer Reading
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {changedDetails?.changeLogs &&
                    changedDetails?.changeLogs?.map(
                      (log: any, index: number) => (
                        <TableRow key={index}>
                          <TableCell sx={tableCellStyles}>
                            {log?.updatedBy?.name || "-"}
                          </TableCell>
                          <TableCell sx={tableCellStyles}>
                            {formatDate(log?.timestamp)}
                          </TableCell>
                          <TableCell sx={tableCellStyles}>
                            {log?.previousData?.tripType}
                          </TableCell>
                          <TableCell sx={tableCellStyles}>
                            {log?.previousData?.fromLocation}
                          </TableCell>
                          <TableCell sx={tableCellStyles}>
                            {log?.previousData?.toLocation}
                          </TableCell>
                          <TableCell sx={tableCellStyles}>
                            {formatDate(log?.previousData?.journeyStartDate)}
                          </TableCell>
                          <TableCell sx={tableCellStyles}>
                            {formatDate(log?.previousData?.journeyReturnDate)}
                          </TableCell>
                          <TableCell sx={tableCellStyles}>
                            {log?.previousData?.vehicleOdometerStart || "-"}
                          </TableCell>
                          <TableCell sx={tableCellStyles}>
                            {log?.previousData?.vehicleOdometerEnd || "-"}
                          </TableCell>
                        </TableRow>
                      )
                    )}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default BasicChangeLogs;
